import { css, cx } from '@emotion/css';
import React, { forwardRef, cloneElement } from 'react';
import { IconCheckSelected, IconCheckUnselected, IconCheckMultiselect, theme, } from '@contrast-security-inc/design-system-foundations';
import { IconInputBase, iconInputStyles } from '../IconInputBase/IconInputBase';
const checkboxInputStyles = css `
  display: flex;

  &:checked + label span svg {
    fill: ${theme.color.turquoise70};
  }

  &:not(:checked) + label span svg {
    fill: ${theme.color.neutral70};
  }

  &:not(:checked,:disabled) + label span:hover svg {
    fill: ${theme.color.neutral90};
  }

  &:checked:not(:disabled) + label span:hover svg {
    fill: ${theme.color.turquoise90};
  }

  &:disabled + label span {
    opacity: 0.4;
  }

  &:disabled + label {
    cursor: not-allowed;
  }

  &:not(:disabled) + label {
    cursor: pointer;
  }

  &:focus-visible + label span {
    outline: 2px auto ${theme.color.neutral80};
    padding-top: 0px;
    padding-bottom: 0px;

    ::before {
      width: 22px;
      height: 22px;
      margin-left: -2px;
    }
  }

  &:focus-visible:not(:checked) + label span {
    outline: 2px auto ${theme.color.turquoise70};
  }
`;
const checkboxStyles = css `
  width: 24px;
  height: 24px;
  display: inline-flex;
`;
export const Checkbox = forwardRef(({ 'aria-label': ariaLabel, className, error, errorPlacement, id, isChecked = false, isDisabled, isMultiSelect, label, onChange, ref: _ref, style, testId, useInlineError, value, ...rest }, ref) => {
    const iconProps = {
        size: 'md',
        testId: testId && `${testId}-icon`,
    };
    const getIcon = (checked, multiselect) => {
        if (checked && !multiselect) {
            return React.createElement(IconCheckSelected, { color: "turquoise70", ...iconProps });
        }
        else if (checked && multiselect) {
            return React.createElement(IconCheckMultiselect, { color: "turquoise70", ...iconProps });
        }
        else {
            return React.createElement(IconCheckUnselected, { color: "neutral70", ...iconProps });
        }
    };
    const icon = getIcon(isChecked, isMultiSelect);
    const onCheckedChange = (event) => {
        if (!isDisabled) {
            onChange(event, !isChecked);
        }
    };
    const getAriaChecked = (isChecked, isMultiSelect) => {
        if (isChecked) {
            if (isMultiSelect) {
                return 'mixed';
            }
            else {
                return 'true';
            }
        }
        else {
            return 'false';
        }
    };
    return (React.createElement(React.Fragment, null, cloneElement(React.createElement(IconInputBase, { "aria-label": ariaLabel, className: cx(className, 'ds-checkbox'), error: error, errorPlacement: errorPlacement, font: 'body', id: id, isDisabled: isDisabled, label: label, renderInput: () => (React.createElement("input", { checked: isChecked, className: cx(checkboxInputStyles, iconInputStyles(isDisabled)), disabled: isDisabled, onChange: onCheckedChange, readOnly: true, type: "checkbox", "aria-checked": getAriaChecked(isChecked, isMultiSelect), value: value, ...rest })), style: style, testId: testId, useInlineError: useInlineError },
        React.createElement("span", { className: checkboxStyles, style: style, "data-testid": testId && `${testId}-checkbox` }, icon)), { ref: ref })));
});
Checkbox.displayName = 'Checkbox';
